import * as Schema from '../schema';
import assembleEntity from '../schema/assembleEntity';
import { createSelector } from 'reselect';
import { linkForNamedEntity } from '../utils/category-page';

export function selectInstrument(state, id) {
  return state.entities.instruments[id];
}

export const selectInstruments = createSelector(
  [state => state.entities, state => state.lists.instruments.entities],
  (entities, instruments) => assembleEntity(Schema.InstrumentList, entities, instruments)
);

export const selectInstrumentsLinks = createSelector([selectInstruments], instruments =>
  instruments.map(linkForNamedEntity('instruments'))
);
